import { Row, Button } from 'antd';
import styled from 'styled-components';

const OverLay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(11, 12, 38, 0.5);
  display: flex;
  align-content: center;
  align-items: center;
`;

const TitleCarousel = styled.h1`
  text-transform: capitalize;
  font-weight: 700;
  line-height: 1.2;
  font-size: 58px;
  margin-bottom: ${(props) => (props.marginbt ? '30px' : 0)};
  color: #fff;
  text-align: center !important;
`;

const ContentCarousel = styled.p`
  margin-bottom: 30px;
  font-size: 18px;
  line-height: 1.4;
  font-weight: 400;
  color: #fff;
`;

const CarouselRow = styled(Row)`
  margin: auto;
`;

const CarouselContentWrapper = styled.div`
  text-align: center;
`;

const CarouselButton = styled(Button)`
  &&& {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    font-weight: 600;
    font-size: ${(props) => props.theme.textSizeLarge};
  }
`;

export {
  OverLay,
  TitleCarousel,
  ContentCarousel,
  CarouselContentWrapper,
  CarouselRow,
  CarouselButton,
};
